import { createApp } from 'vue'
import CategoryListContent from '~/js/components/categoryListContent'

const ID = 'js-category-list'

document.addEventListener('DOMContentLoaded', async () => {
  const element = document.getElementById(ID)
  if (!element) return

  createApp({
    name: 'CategoryListPage',
    components: {
      CategoryListContent,
    },
  }).mount(element)
})
